import MessageModal from '@components/shared/MessageModal'
import useModal from '@hooks/useModal'
import React, { useEffect } from 'react'

interface Props {
  resetBoundary?: () => void
  children: React.ReactNode
  error?: Error
}

const ModalFallBack = ({ resetBoundary, children, error }: Props) => {
  const [openResModal] = useModal()
  useEffect(() => {
    const tiggerModal = async () => {
      const res = await openResModal(
        <MessageModal>{error?.message}</MessageModal>
      )
      if (res) {
        resetBoundary?.()
      }
    }
    tiggerModal()
  }, [])
  return <>{children}</>
}

export default ModalFallBack
